import { Field } from "formik"

function Input({ type, name, placeholder, component, className }) {
    return (
        <Field
            type={type}
            name={name}
            component={component}
            placeholder={placeholder}
            autoComplete="off"
            className={"w-full outline-none border-2 border-[#D4D4D4] bg-none rounded-2xl py-4 px-6 text-lg" + className} />
    )
}

export default Input